module.exports = "<div class=\"call-dialog\">\n  <div class=\"call-info\">\n    <img\n      class=\"md-media-sm\"\n      ng-src=\"{{ $ctrl.customer.picture.value }}\"\n      alt=\"\"\n    />\n    <span>{{::$ctrl.customer.name.value}}</span>\n    <span>+{{::$ctrl.customer.phone.value}}</span>\n  </div>\n  <call\n    status=\"$ctrl.callState\"\n    start-watch-event=\"$ctrl.startWatchEvent\"\n    clear-watch-event=\"$ctrl.clearWatchEvent\"\n    end-call-event=\"$ctrl.endCallEvent\"\n  ></call>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/customer/callDialog/callDialog.html
// module id = 1256
// module chunks = 0